
import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";
const DEFAULT_SECONDARY_COLOR = "var(--label-tertiary)";

function IconGrid({
    class: cssClass,
    color,
    secondaryColor
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;
    const secondaryFill = secondaryColor ?? `var(--icon-secondary-color, ${DEFAULT_SECONDARY_COLOR})`;

    return (
        <svg class={cssClass} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={secondaryFill} opacity=".6" d="M3 4h5v10H3z"/>
            <path fill={secondaryFill} opacity=".3" d="M8 4h7v10H8z"/>
            <path stroke={fill} d="M14.5 3.5v11" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2"/>
            <rect fill={fill} x="3" y="3" width="1" height="12" rx=".5"/>
            <rect fill={fill} x="7" y="3" width="1" height="12" rx=".5"/>
        </svg>
    );
}

export default IconGrid;
